<template>
  <div class="right_main">
    <div class="main_con flex">
      <div class="special_right_main column">
        <div class="head_row flex">
          
          <el-button type="primary" size="mini" round @click="showGuide = true">新手指引</el-button>
          <div v-show="false" class="search_area">
            <img class="search_icon" src="@/assets/img/search_2.png" alt="" />
            <input
              class="search_con"
              type="text"
              placeholder="请输入关键词"
              v-model="searchInput"
              @compositionstart="handleCompositionStart"
              @compositionend="handleCompositionEnd"
              @input="handleInput"
            />
          </div>
          <span class="date"
            >数据统计时间：{{
              $dateTypeFormat("YYYY年mm月dd日 HH:MM:SS", new Date())
            }}</span
          >
        </div>
        <div class="card_con">
          <div class="card_1">
            <div class="row1 flex">
              <span>个人资料</span>
            </div>
            <div class="info_con flex">
              <img
                v-if="userInfo.loginUser?.avatar"
                class="logo"
                :src="userInfo.loginUser?.avatar"
                alt=""
              />
              <div v-else class="logo" style="background: #f9f9f9"></div>

              <div class="des_con column">
                <span class="name">{{ userInfo.loginUser?.nickname }}</span>
                <span class="years">{{ userInfo.loginUser?.workJob }}</span>
              </div>

              <!-- <img class="contact phone" src="@/assets/img/phone.png" alt="" /> -->
              <div class="contact_con" style="margin-left: auto">
                <img
                  class="contact wechat"
                  src="@/assets/img/wechat.png"
                  alt=""
                />
                <div class="code_con">
                  <div class="head">二维码</div>
                  <div class="main flex">
                    <img
                      v-if="userInfo?.loginUser?.wxUrl"
                      :src="userInfo?.loginUser?.wxUrl"
                      alt=""
                    />
                    <span v-else>还未上传微信二维码</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="subtitle">联系方式</div>
            <div class="info_con2 flex">
              <div class="info_item">
                <span>联系电话：</span>
                <span>{{ userInfo?.loginUser?.mobile }}</span>
              </div>

              <div class="info_item">
                <span>电子邮箱：</span>
                <span>{{ userInfo?.loginUser?.email }}</span>
              </div>

              <div class="info_item">
                <span>所属行业：</span>
                <span>{{ userInfo?.loginUser?.profession }}</span>
              </div>
            </div>
          </div>
          <div class="card_2_con column">
            <div class="card_2 column">
              <span>昨日浏览数（次）</span>
              <span>{{ nums.visitNum }}</span>
              <img src="@/assets/img/card_back1.png" alt="" />
            </div>
            <div class="card_2 column" style="margin-top: 20px">
              <span>昨日分享数（次）</span>
              <span>{{ nums.shareNum }}</span>
              <img src="@/assets/img/card_back2.png" alt="" />
            </div>
          </div>
          <div class="card_3 column">
            <span class="card_3_title">你的小程序创作展示</span>
            <span class="card_3_des"
              >这里是您的小程序介绍产品简介客户丰富场景，持续支持
              提供各种行业解决方，产品简介客户丰富场景，持续支持
              提供各种行业解决方案。</span
            >
            <div class="btn_area flex">
              <div class="btn btn_type2 preview-btn" @click="changeShow">
                手机预览
                <div
                  class="code_con"
                  style="display: block; left: -50%"
                  v-if="showMiniProgaramCode"
                  ref="xcxQrcode"
                >
                  <div class="head">二维码</div>
                  <div class="main flex">
                    <img
                      v-if="miniProgaramCode"
                      :src="miniProgaramCode"
                      alt=""
                    />
                    <span v-else>二维码生成中</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- <img
          class="show_code"
          :class="{ location_expand: showCode }"
          src="@/assets/img/show_code.png"
          alt=""
          @click="showCode = !showCode"
        />
        <div class="code_area" :class="{ area_expand: showCode }">
          <div class="tips">
            <img class="code_icon" src="@/assets/img/code_icon.png" alt="" />
            <span>点击扫码预览查看你的小程序</span>
          </div>
          <div class="code" v-show="showCode"></div>
        </div> -->
          </div>
        </div>
        <div class="brand_management">
          <div class="title">品牌管理</div>
          <div class="func_list">
            <div
              class="func_item column"
              v-for="item in funcList"
              :key="item.name"
            >
              <img class="func_icon" :src="item.icon" alt="" />
              <span class="func_name">{{ item.name }}</span>
              <span class="func_des">{{ item.des }}</span>
              <div class="func_button" @click="clickHandle(item)">
                {{ item.button }}
              </div>
            </div>
          </div>

          <new-user-guide
            :visible="showGuide"
            @onNext="onNext"
            @onPrev="onPrev"
            :content="guideContent"
            :guide-index="guideIndex"
            :last-index="lastIndex"
            :arrow-position="arrowPosition"
            :top="top"
            :left="left"
          ></new-user-guide>
        </div>
      </div>
    </div>
    <CreatePDF v-if="showCreatePDF" @close="showCreatePDF = false" />
    <CreateBusinessCard
      v-if="showCreateBusinessCard"
      @close="showCreateBusinessCard = false"
    />
  </div>
</template>

<script>
import CreatePDF from "@/components/CreatePDF.vue";
import CreateBusinessCard from "@/components/CreateBusinessCard.vue";
import {
  getUserQrCode,
  getXcxQrCode,
  userStatic,
  getAppList,
} from "@/assets/js/request";
import { mapState, mapMutations } from "vuex";
import NewUserGuide from "@/components/NewUserGuide.vue";
export default {
  name: "HomeView",
  components: {
    CreatePDF,
    CreateBusinessCard,
    NewUserGuide,
  },
  computed: {
    ...mapState(["userInfo", "activeCompanyInfo", "paramsId"]),
    usedAppId() {
      return this.$store.state.usedAppId;
    },
  },
  watch: {
    paramsId: {
      handler: function (newVal) {
        userStatic().then((res) => {
          if (res.code == 200) {
            this.nums = res.data;
            this.getAppList();
          }
        });
      },
      immediate: true,
    },

    guideIndex: {
      handler(newVal) {
        if (newVal === 1) {
          this.guideContent = "在这里填写你的个人/公司/工作室资料";
          this.left = -82;
          this.top = 170;
          this.arrowPosition = "bottom";
        } else if (newVal === 2) {
          this.guideContent = "在这里上传/浏览你的作品";
          this.left = 237;
          this.top = 170;
          this.arrowPosition = "bottom";
        } else if (newVal === 3) {
          this.guideContent = "在这里编辑/查看你的不同风格的小程序首页";
          this.left = 568;
          this.top = 150;
          this.arrowPosition = "bottom";
        } else if (newVal === 4) {
          this.guideContent = "在这里编辑/查看你的不同风格的PDF";

          this.top = 170;
          this.left = 893;
          this.arrowPosition = "bottom";
        } else if (newVal === 5) {
          this.guideContent = "在这里生成跳转到你的小程序首页的二维码";

          this.top = -25;
          this.left = 633;
          this.arrowPosition = "top";
        }
      },
      immediate: true,
    },
    "userInfo.loginUser.id": {
      handler: function (newVal) {
        if (newVal) {
          const guideInfo = localStorage.getItem(newVal + "mphzGuideInfo");
          if (!guideInfo || !JSON.parse(guideInfo).home) this.showGuide = true;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      searchInput: "", //用户搜索
      nums: {
        shareNum: 0,
        visitNum: 0,
      },
      showCode: false,
      funcList: [
        {
          name: "资料设置",
          icon: require("@/assets/img/func_1.png"),
          des: "上传头像，编辑姓名、简介、成员等",
          button: "去编辑",
        },
        {
          name: "作品管理",
          icon: require("@/assets/img/func_4.png"),
          des: "多种展示方式，提高客户转化率",
          button: "去管理",
        },
        {
          name: "生成小程序",
          icon: require("@/assets/img/func_2.png"),
          des: "设置小程序模板",
          button: "去生成",
        },
        // {
        //   name: "生成名片",
        //   icon: require("@/assets/img/func_3.png"),
        //   des: "朋友圈名片海报，更好的传播方式",
        //   button: "去设置",
        // },
        {
          name: "生成介绍PDF",
          icon: require("@/assets/img/func_5.png"),
          des: "简介PDF，更好的传播方式",
          button: "去生成",
        },
      ],
      showCreateBusinessCard: false,
      showCreatePDF: false,
      wechatCode: "",
      miniProgaramCode: "", //小程序二维码
      showMiniProgaramCode: false,
      showGuide: false,
      guideIndex: 1,
      lastIndex: 5,
      guideContent: "",
      top: 0,
      left: 0,
      arrowPosition: "bottom",
    };
  },
  methods: {
    handleCompositionStart() {
      // 开始拼音输入时，移除input事件监听
      this.inputEventBound = false;
    },
    handleCompositionEnd() {
      // 拼音输入结束时，重新绑定input事件监听
      this.inputEventBound = true;
      // 触发input事件，以便处理拼音输入后的逻辑
      this.handleInput();
    },
    handleInput() {
      if (this.inputEventBound) {
        // 只有当input事件监听器是绑定状态时才执行处理逻辑
      }
    },
    clickHandle(item) {
      // if (item.name == "生成小程序" || item.name == "生成介绍PDF") {
      //   if (this.activeCompanyInfo?.status != "2") {
      //     this.$message({
      //       message: `当前企业/工作室信息审核通过后，才可上传企业/工作室作品`,
      //       type: "error",
      //     });
      //     return;
      //   }
      // }
      switch (item.name) {
        case "资料设置":
          this.$router.push("/personalCenter");
          break;
        case "生成小程序":
          this.$router.push("/workManagement?type=1");
          break;
        case "生成名片":
          this.showCreateBusinessCard = true;
          break;
        case "作品管理":
          this.$router.push("/workManagement");
          break;
        case "生成介绍PDF":
          this.$router.push("/workManagement?type=2");
          break;
        default:
          break;
      }
    },
    getWechatCode() {
      if (!this.userInfo?.loginUser?.openId) return;
      getUserQrCode({ openId: this.userInfo?.loginUser?.openId })
        .then((res) => {
          const blob = res;
          this.wechatCode = URL.createObjectURL(blob);
        })
        .catch((error) => {
          console.error("请求失败:", error);
        });
    },
    changeShow() {
      if (this.activeCompanyInfo?.id && this.activeCompanyInfo?.status != "2") {
        this.$message({
          message: `当前企业/工作室信息审核通过后，才能生成预览二维码`,
          type: "warning",
        });
        return;
      }
      this.showMiniProgaramCode = true;
      if (this.showMiniProgaramCode) {
        this.toGetAppQrCode();
      }
    },
    async toGetAppQrCode() {
      try {
        let temp = {
          STUDIO: "1",
          COMPANY: "2",
          USER: "0",
        };
        if (!this.usedAppId) {
          this.$message.warning("没有使用中的小程序模板");
          return;
        }
        let params = {
          scene: `userId=${this.userInfo.loginUser.id}&type=${
            temp[this.userInfo.loginUser.permission]
          }&id=${this.usedAppId}`, //  跳转携带的参数 前端自定义
          page: "pages/home/index",
          version: "release",
        };
        const res = await getXcxQrCode(params);
        this.miniProgaramCode = URL.createObjectURL(res);
      } catch (e) {
        console.error("请求失败:", error);
      }
    },

    async getAppList() {
      try {
        let temp = {
          STUDIO: "1",
          COMPANY: "2",
          USER: "",
        };
        const params = {
          type: temp[this.userInfo.loginUser.permission],
          companyId:
            this.$store.state.userInfo.companyInfo.type === "0"
              ? "0"
              : this.$store.state.paramsId.companyId,
        };
        const res = await getAppList(params);
        const obj = res.data.find((item) => item.appInfoId);
        this.$store.commit("SET_APP_ID", obj ? obj.id : "");
      } catch (error) {}
    },
    onNext() {
      if (this.guideIndex === this.lastIndex) {
        this.guideIndex = 1;
        this.showGuide = false;
        const guideInfo = localStorage.getItem(
          this.userInfo.loginUser.id + "mphzGuideInfo"
        );
        if (!guideInfo) {
          localStorage.setItem(
            this.userInfo.loginUser.id + "mphzGuideInfo",
            JSON.stringify({ home: true })
          );
        } else {
          localStorage.setItem(
            this.userInfo.loginUser.id + "mphzGuideInfo",
            JSON.stringify({ ...JSON.parse(guideInfo), home: true })
          );
        }
      } else {
        this.guideIndex++;
      }
    },
    onPrev() {
      this.guideIndex--;
    },
    // 绑定全局点击事件
    bindClickOutside() {
      // 注意：使用箭头函数确保this指向组件实例
      document.addEventListener("click", this.handleClickOutside);
    },
    // 解绑全局点击事件
    unbindClickOutside() {
      document.removeEventListener("click", this.handleClickOutside);
    },
    // 处理外部点击逻辑
    async handleClickOutside(e) {
      // 忽略按钮自身的点击事件
      if (e.target.closest(".preview-btn") || !this.$refs.xcxQrcode) {
        return;
      }
      // 1. 获取当前组件的根元素（.custom-emoji-com）
      const emojiDiv = this.$refs.xcxQrcode;
      // 2. 判断点击位置是否在emojiDiv内部（包含子元素）
      const isClickInside = emojiDiv.contains(e.target);

      // 3. 若点击外部且当前div显示，则触发关闭
      if (!isClickInside && this.showMiniProgaramCode) {
        this.closeEmojiDiv();
      }
    },
    // 关闭div的核心逻辑（可根据需求调整）
    closeEmojiDiv() {
      this.showMiniProgaramCode = false;
    },
  },
  mounted() {
    this.bindClickOutside();
  },
  // 组件销毁前必须解绑事件，避免内存泄漏
  beforeDestroy() {
    this.unbindClickOutside();
  },
};
</script>
<style lang="scss" scoped>
/* 大屏放大 */
@media (min-width: 2100px) {
  .special_right_main {
    transform: scale(1.5);
  }
}

.main_con {
  height: calc(100vh - 48px);
  justify-content: center;

  .special_right_main {
    align-items: center;
  }
}

.head_row {
  width: 1324px;
  height: 48px;
  margin-bottom: 24px;
  .search_area {
    display: flex;
    align-items: center;
    position: relative;

    .search_icon {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 30px;
      top: 23px;
    }

    .search_con {
      width: 586px;
      height: 68px;
      border-radius: 36px;
      background: #fff;
      border: none;
      outline: none;
      padding: 0 20px 0 77px;

      font-weight: 400;
      font-size: 20px;
      color: #898989;

      &::placeholder {
        font-size: 20px;
        color: #898989;
      }
    }
  }

  .date {
    font-size: 14px;
    color: #242424;
    margin-left: auto;
  }
}

.card_con {
  display: flex;
  align-items: flex-start;

  .card_1 {
    width: 482px;
    height: 252px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;

    .row1 {
      span {
        font-weight: 600;
        font-size: 20px;
        color: #242424;
      }

      .edit {
        width: 60px;
        height: 28px;
        border-radius: 100px;
        border: 1px solid #242424;
        font-size: 14px;
        color: #242424;
        justify-content: center;
        margin-left: auto;
        cursor: pointer;
      }
    }

    .info_con {
      margin: 22px 0;

      .logo {
        width: 64px;
        height: 64px;
        border-radius: 10px;
      }

      .des_con {
        margin-left: 16px;

        .name {
          height: 28px;
          font-weight: 500;
          font-size: 20px;
          color: #242424;
          line-height: 28px;
        }

        .years {
          height: 22px;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
          margin-top: 3px;
        }
      }

      .contact_con {
        position: relative;

        &:hover {
          .code_con {
            display: block;
          }
        }

        .contact {
          width: 32px;
          height: 32px;
          cursor: pointer;
        }
      }
    }

    .subtitle {
      height: 24px;
      font-weight: 600;
      font-size: 16px;
      color: #242424;
      line-height: 24px;
    }

    .info_con2 {
      margin-top: 8px;
      justify-content: space-between;
      padding-right: 20px;

      .info_item {
        display: flex;
        flex-direction: column;

        span:nth-of-type(1) {
          height: 22px;
          font-size: 14px;
          color: #717171;
          line-height: 22px;
        }

        span:nth-of-type(2) {
          height: 22px;
          font-weight: 600;
          font-size: 14px;
          color: #242424;
          line-height: 22px;
        }
      }
    }
  }

  .code_con {
    display: none;
    width: 152px;
    height: 178px;
    background: #ffffff;
    border-radius: 2px;
    box-shadow: 0px 3px 24px 0px rgba(151, 151, 151, 0.08);
    position: absolute;
    top: 47px;
    left: -60px;
    z-index: 2;

    .head {
      height: 34px;
      border-bottom: 1px solid #dedede;
      padding-left: 16px;
      line-height: 34px;
      font-weight: 500;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      text-align: left;
    }

    .main {
      height: 144px;
      justify-content: center;

      > img {
        width: 120px;
        height: 120px;
      }

      > span {
        font-size: 14px;
        color: #717171;
      }
    }
  }

  .card_2_con {
    display: flex;
    flex-direction: column;
    margin: 0 24px;

    .card_2 {
      width: 313px;
      height: 116px;
      background: #ffffff;
      border-radius: 12px;
      position: relative;

      span {
        margin-left: 20px;

        &:nth-of-type(1) {
          height: 24px;
          font-size: 16px;
          line-height: 24px;
          color: #717171;
          margin-top: 20px;
        }

        &:nth-of-type(2) {
          height: 36px;
          font-weight: 600;
          font-size: 36px;
          color: #242424;
          line-height: 36px;
          margin-top: 16px;
        }
      }

      img {
        position: absolute;
        width: 100px;
        height: 65px;
        right: 11px;
        bottom: 0;
      }
    }
  }

  .card_3 {
    width: 482px;
    height: 252px;
    border-radius: 12px;
    position: relative;
    background: #fff url("@/assets/img/card_3_back.png") no-repeat bottom right /
      242px 133px;
    padding: 20px;

    .card_3_title {
      height: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 20px;
      color: #242424;
      line-height: 28px;
    }

    .card_3_des {
      font-size: 12px;
      color: #666666;
      line-height: 20px;
      width: 441px;
      margin-top: 20px;
    }

    .btn_area {
      margin-top: auto;

      .btn {
        text-align: center;
        line-height: 32px;
        font-size: 12px;
        border-radius: 100px;
        padding: 0 16px;
        height: 32px;
        cursor: pointer;
      }

      .btn_type1 {
        margin-right: 16px;
        cursor: pointer;
      }

      .btn_type2 {
        background: #242424;
        color: #f3f3f3;
        border: 1px solid #242424;
        line-height: 30px;
        position: relative;
      }
    }

    .card_3_back {
      width: 290px;
      height: 250px;
      margin-top: 26px;
      background: #9ce14a;
      opacity: 0.67;
    }

    .show_code {
      width: 58px;
      height: 58px;
      position: absolute;
      right: 71px;
      bottom: -27px;
      z-index: 2;
      cursor: pointer;
    }

    .location_expand {
      bottom: -120px;
      transform: scaleY(-1);
    }

    .code_area {
      width: 600px;
      height: 54px;
      position: absolute;
      left: 37px;
      bottom: -54px;
      z-index: 1;
      background: linear-gradient(180deg, #f4f9ef, #fff);
      border-radius: 0 0 20px 20px;
      border: 1px solid #d5f2b3;
      border-top: none;

      .tips {
        display: flex;
        align-items: center;
        margin-left: 29px;
        margin-top: 15px;

        .code_icon {
          width: 20px;
          height: 20px;
        }

        span {
          font-weight: 400;
          font-size: 14px;
          color: #606060;
          margin-left: 9px;
        }
      }

      .code {
        background: #898989;
        width: 70px;
        height: 70px;
        margin-left: 58px;
        margin-top: 14px;
      }
    }

    .area_expand {
      height: 150px;
      bottom: -150px;
    }
  }
}

.brand_management {
  width: 1324px;
  height: 443px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  margin-top: 24px;
  position: relative;
  z-index: auto;
  .title {
    font-weight: 600;
    font-size: 20px;
    color: #242424;
  }

  .func_list {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;

    .func_item {
      // width: 244px;
      width: 100%;
      height: 355px;
      background: #fbfbfb;
      border-radius: 12px;
      border: 1px solid #ffffff;
      align-items: center;
      margin-right: 16px;

      &:last-of-type {
        margin-right: 0px;
      }

      .func_icon {
        width: 64px;
        height: 64px;
        margin-top: 64px;
      }

      .func_name {
        font-weight: 600;
        font-size: 16px;
        color: #242424;
        margin-top: 26px;
      }

      .func_des {
        font-size: 14px;
        color: #717171;
        margin-top: 10px;
      }

      .func_button {
        width: 90px;
        height: 36px;
        background: #242424;
        border-radius: 100px;

        font-size: 14px;
        color: #f3f3f3;
        line-height: 36px;
        text-align: center;
        margin-top: 49px;
        cursor: pointer;
      }
    }
  }
}
</style>
